<template>
    <b-row>
        <div class="title mt-3">
            {{ title }}
        </div>
    </b-row>
</template>
<script>
export default {
    props: ["title"]
};
</script>
<style lang="scss"></style>
